import axios from "axios"
import { getCourseOnServer, MappedCourseServer } from "../../../prismic/mapDataOnServer"
import { registrationLinkEmailUtmParameters } from "../../registrationQrEmailUtmParameters"
import { getWebSiteUrlFromWindow } from "../../../url/getWebSiteUrlFromWindow"
import { generateEmailCallToActionButton, generateEmailHeading3, generateEmailParagraph, spaceDivider } from "../../generateEmailParagraph"
import { getAdditionallyCourses } from "../../../prismic/courses"
import { PrismicDocument } from "@prismicio/types"

const removePattern = (text: string): string => {
  return text.replace(/\(\d+-\d+ let\)/, "").trim()
}

const getCourseListWrappedOffer = (courses: MappedCourseServer[]): string => {
  if (courses?.length === 0) {
    return ""
  }

  const webUrl = getWebSiteUrlFromWindow() || "https://vzdelanibudoucnosti.cz"

  return `
     <table align="center" border="0" cellpadding="0" cellspacing="0" role="presentation" style="background:#ffffff;background-color:#ffffff;width:100%">
        <tbody>
           <tr>
              <td style="direction:ltr;font-size:0px;padding:9px 0px 9px 0px;text-align:center">
                 ${courses
                   .map((c) => getCourseDetailOffer(removePattern(c.name), `${webUrl}${c.registerUrl}${registrationLinkEmailUtmParameters}`, c.excerptAsText))
                   .join("")}
              </td>
           </tr>
        </tbody>
     </table>
  `
}

const getCourseDetailOffer = (title: string, url: string, shortText: string, buttonText = "Více informací") => `
  ${generateEmailHeading3(title, url)}
  ${generateEmailParagraph(shortText, "text-align: left; margin-bottom: 10px;")}
  ${generateEmailCallToActionButton(buttonText, buttonText, url, true)}
  ${spaceDivider}
`

export const generateEmailCourseListOfferOnClient = async (slug?: string): Promise<string> => {
  const courses = await axios
    .post<PrismicDocument<Record<string, any>, string, string>[]>("/api/course/coursesOffer", { slug, apiKey: process.env.NEXT_PUBLIC_API_KEY })
    .then((res) => res.data)
    .catch((error) => console.error(error))

  const mappedCourses = (courses || []).map((d) => getCourseOnServer(d))

  return getCourseListWrappedOffer(mappedCourses.slice(0, 4))
}

export const generateEmailCourseListOfferOnServer = async (slug?: string): Promise<string> => {
  const courses = await getAdditionallyCourses(slug)

  const mappedCourses = (courses || []).map((d) => getCourseOnServer(d))

  return getCourseListWrappedOffer(mappedCourses.slice(0, 4))
}
